export const integrationsDirectCdiSourcesSourceIdDistinctColumnValues =
  "/integrations/direct/cdi/sources/:source_id/distinct_column_values";
